import { auth, useAuthState } from 'api/services/firebase';
import useAccountStore from 'store/accountStore';
import AttachCardBanner from './AttachCardBanner';
import SignUpBanner from './SignUpBanner';

const ActionableBanner = () => {
  const [user] = useAuthState(auth);
  const { promoStatus, isLoading } = useAccountStore(
    (state) => ({
      promoStatus: state.activeAccount.promoStatus,
      isLoading: state.account.isLoading,
    }),
  );

  // const isLoggedIn = !!user;
  //
  // if (!isLoggedIn) return <SignUpBanner />;

  // if (!promoStatus && !isLoading) return <AttachCardBanner />;

  return null;
};

export default ActionableBanner;
